import { getField } from 'vuex-map-fields';

export default {
  getField,
  fitsFormat(state, { pageDimensions }) {
    return (formatProperty, position) => {
      return position <= pageDimensions[formatProperty]
    }
  },
  fitsFormatHeight(state, { fitsFormat }) {
    return (position) => fitsFormat('availableHeight', position)
  },
  fitsFormatWidth(state, { fitsFormat }) {
    return (position) => fitsFormat('availableWidth', position)
  },
  getCovertedSize() {
    return (value, dpi = 300) => {
      const conversion = ((value * 25.4) / dpi)

      return Math.round(conversion * 10) / 10
    }
  },
  getImageRealSize(state, { getCovertedSize }) {
    return ({ width, height }) => ({
      width: getCovertedSize(width),
      height: getCovertedSize(height)
    })
  },
  pageDimensions({ formats, format = 'a4', orientation = 'landscape' }) {
    return formats[format][orientation];
  },
}